import callApi from '../../util/apiCaller';

import { checkVariables } from './VariableActions';
import { setPages } from '../Page/PageActions';
import { setQuestions } from '../Question/QuestionActions';
import { setIsFetching, FETCH_LIMIT, getItemsRequest } from '../App/AppActions';

// Export Constants
export const SET_SUBJECTS = 'SET_SUBJECTS';
export const SUBJECT_STATUS_PENDING = 'pending';

export function getSubjectsCountRequest(search = '', filters = null) {
    return dispatch => {
        return callApi(`subjects/count?${search ? `search=${search}&` : ''}${filters ? `${Object.keys(filters).map(filterKey => `filters[${filterKey}]=${filters[filterKey]}`).join('&')}&` : ''}`).then(result => {
            return result.count;
        }).catch(err => {
            return null;
        });
    };
}

export function getSubjectsRequest(search = '', filters = null, sorter = null, pager = null) {
    return dispatch => dispatch(getItemsRequest('subjects', null, items => dispatch(setSubjects(items)), { search, filters, sorter, pager }));
}

export function getPublicSubjectsRequest() {
    return dispatch => {
        dispatch(setIsFetching('subjects'));
        return callApi('subjects/public').then(result => {
            dispatch(setSubjects(result.subjects, true));
            return result.subjects;
        }).catch(err => {
            return null;
        });
    };
}

export function getSubjectRequest(subjectId) {
    return dispatch => {
        return subjectId ? callApi(`subject/${subjectId}`).then(result => {
            result.subject && dispatch(setSubjects([result.subject], true));
            result.pages && dispatch(setPages(subjectId, result.pages));
            result.questions && dispatch(setQuestions(subjectId, result.questions));
            return result;
        }).catch(err => {
            console.error(err);
            return null;
        }) : Promise.resolve(null);
    };
}

export function editSubjectRequest(subject) {
    return dispatch => {
        return callApi('subject/edit', 'post', { subject }).then(result => {
            result.subject && dispatch(getSubjectRequest(result.subject._id));
            return result.subject;
        }).catch(err => {
            return null;
        });
    };
}

export function duplicateSubjectRequest(subjectId) {
    return dispatch => {
        return callApi(`subject/clone/${subjectId}`).then(result => {
            result.subject && dispatch(getSubjectRequest(result.subject._id));
            return result.subject;
        }).catch(err => {
            return null;
        });
    };
}

export function removeSubjectRequest(subjectId) {
    return dispatch => {
        return callApi('subject/remove', 'delete', { subject: { _id: subjectId } }).then(result => {
            // dispatch(getSubjectsRequest());
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

// Getters
export function getSubjects(store, isPublic = null) {
    let subjects = store.subjects.data;
    if(isPublic !== null) {
        subjects = store.subjects.data.filter(subject => subject.isPublic === isPublic);
    }
    return subjects;
}

export function getSubject(store, id) {
    return store.subjects.data.find(subject => subject._id === id);
}

export function getSubjectAuthorId(subject) {
    return (subject.author && subject.author._id) || subject.author;
}

export function getSubjectsTags(store) {
    const tags = [];
    getSubjects(store).map(subject => subject.tags).forEach(tagsList => {
        tagsList.forEach(tag => !tags.includes(tag) && tags.push(tag));
    });
    return tags;
}

export function getSubjectOption(subject, option) {
    if(subject && subject.options) {
        return subject.options[option];
    }
    return '';
}

export function canEditSubject(subject, user) {
    return subject && user && (
        ((user.institutions || []).some(institution => (subject.institutions || []).includes(institution)) || user.institutions.includes('*'))
        && (['root', 'admin', 'manager', 'professor'].includes(user.role) || (getSubjectAuthorId(subject) === user._id && !['proctor', 'corrector', 'student'].includes(user.role)))
    );
}

export function checkSubjectVariables(subject) {
    return checkVariables([subject.title, subject.content], subject.variables);
}

// Export Actions
export function setSubjects(subjects, isAddMode = false) {
    return {
        type: SET_SUBJECTS,
        subjects,
        isAddMode,
    };
}
